import pub from './../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    areaDimension: '呎',
    whatsAppShare1: ['業主', '您好，我對您在House730的放盤有興趣', '您好，我對您在House730的租盤有興趣', '售', '月租', '面積', '想查詢更多：'],
    plane: '平面圖',
    saleFormUnpaid: '未補',
    saleFormPaid: '已補',
    myFavourites: '樓盤收藏',
    subscribe:'樓盤訂閱',
    residential: '住宅',
    offices: '工商',
    delColTit: '確定清除已收藏樓盤？',
    clear: '清空',
    find: '目前顯示',
    agencyPage: '個人專頁',
    copySuccessText: '已成功複製連結',
    propertiesRent: '個可查看的收藏租盤',
    propertiesSale: '個可查看的收藏售盤',
    propertiesNew: '個可查看的收藏一手新盤',
    wuEst: '個可查看的收藏屋苑',
    noInfo: '沒有相關記錄',
    browseHistory: '瀏覽記錄',
    noMore: '沒有更多了',
    loading: '加載中',
    messageTit: '確定清除瀏覽記錄？',
    confirmButtonText: '確定',
    cancelButtonText: '取消',
    sale:'售盤',
    esSale: '買樓',
    rent: '租樓',
    newSale:'一手新盤',
    estate:'屋苑',
    estateActual:'實',
    vrFind: 'VR睇樓',
    aerial: '航拍VR',
    listBuy: '售',
    listRent: '租',
    monDeal:'月成交',
    dealSaleCountUnit: '宗',
    chi: '呎',
    collectionNotes: '收藏備註',
    shortRent: '短租',
    sublet: '分租',
    verifyLabel: '樓盤已驗證',
    // newPrice:'發展商還未有發出價單',
    // newSalePrice:'樓盤已開始發售',
    isnewPrice:'張價單',
    chi:'呎',
    landlord: '業主自讓盤',
    Landlord: '業主盤',
    agency: '代理盤',
  },
  "zh-cn": {
    areaDimension: '尺',
    whatsAppShare1: ['业主', '您好，我对您在House730的放盘有兴趣', '您好，我对您在House730的租盘有兴趣', '售', '月租', '面积', '想查询更多：'],
    plane: '平面图',
    saleFormUnpaid: '未补',
    saleFormPaid: '已补',
    myFavourites: "楼盘收藏",
    subscribe:'楼盘订阅',
    residential: "住宅",
    offices: "工商",
    delColTit: "确定清除已收藏楼盘？",
    clear: "清空",
    find: "目前显示",
    agencyPage: '个人专页',
    copySuccessText: '已成功复制链接',
    propertiesRent: '个可查看的收藏租盘',
    propertiesSale: '个可查看的收藏售盘',
    propertiesNew: '个可查看的收藏一手新盘',
    wuEst: '个可查看的收藏屋苑',
    noInfo: "没有相关记录",
    browseHistory: "浏览记录",
    noMore: "沒有更多了",
    loading: "加载中",
    messageTit: "确定清除浏览记录？",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    sale:"售盘",
    esSale: "买楼",
    rent: "租楼",
    newSale:'一手新盘',
    estate:'屋苑',
    estateActual:'实',
    vrFind: 'VR睇楼',
    aerial: '航拍VR',
    listBuy: '售',
    listRent: '租',
    monDeal:'月成交',
    dealSaleCountUnit: '宗',
    chi: '尺',
    collectionNotes: "收藏备注",
    ShortRent: '短租',
    sublet: '分租',
    verifyLabel: '楼盘已验证',
    // newPrice:'发展商还未有发出价单',
    // newSalePrice:'楼盘已开始发售',
    isnewPrice:'张价单',
    chi:'尺',
    landlord: '业主自让盘',
    Landlord: '业主盘',
    agency: '代理盘',
  },
  "en-us": {
    areaDimension: 'sq. ft.',
    whatsAppShare1: ['Landlord', 'I am interested in your property for sale in House730', 'I am interested in your property for rent in House730.com', 'Price', 'Rent', 'Area', ' I would like to ask for more information：'],
    plane: 'Floor Plan',
    saleFormUnpaid: 'Prem. Unpaid',
    saleFormPaid: 'Prem. Paid',
    myFavourites: "My Bookmark",
    subscribe:'Property Subscription',
    residential: "Residential",
    offices: "Offices",
    delColTit: "Clear bookmarked property?",
    clear: "Empty",
    find: "Currently showing ",
    agencyPage: 'Agency Page',
    copySuccessText: 'Copied to Clipboard',
    propertiesRent: ' accessible saved for-rent listings',
    propertiesSale: ' accessible saved for-sale listings',
    propertiesNew: ' accessible saved new properties',
    wuEst: ' accessible saved estates',
    noInfo: "No relevant records found",
    browseHistory: "Browsing History",
    noMore: "No More",
    loading: "loading",
    messageTit: "Clear browsing history?",
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    sale:"Sale",
    esSale: "Sale",
    rent: "Rent",
    newSale:'New',
    estate:'Estate',
    estateActual:'SA',
    vrFind: 'VR',
    aerial: 'Aerial VR',
    listBuy: 'Sale',
    listRent: 'Rent',
    monDeal:'Transaction Volume in',
    dealSaleCountUnit:'宗',
    chi: '呎',
    collectionNotes: "Bookmark Property Notes",
    ShortRent: 'Short-term',
    sublet: 'Share',
    verifyLabel: 'Verified',
    chi:'sq.ft.',
    // newPrice:'No price list yet',
    // newSalePrice:'The development is for sale now',
    isnewPrice:' Price Lists',
    landlord: 'Landlord',
    Landlord: 'Landlord',
    agency: 'Agency',
  },
}
export default language[type]